import style from '../CSS/RoundVideoResult.module.css'

const Banner = ({title, coverPhoto}) => {
    return (
        <>
            <div className={style.banner} style={{
                backgroundImage: `url(${coverPhoto})`
            }}>
                <div className={style.banner__overlay}>
                    <h4>{title}</h4>
                </div>
            </div>
        </>
    );
};

export default Banner;